import { createAction, props } from '@ngrx/store';
import { ImportError } from '../../../models';
import {MenuImportDto} from "../../../models/menu.import.dto";

export enum AdminActionTypes {
  LoadImportErrors = '[ImportErrors] Load Import Errors',
  UpsertImportErrors = '[ImportErrors] Upsert Import Errors',
  ResetImportErrors = '[ImportErrors] Reset Import Errors',
  SetImportErrorCurrentPage = '[ImportErrors] Set Import Error Current Page',
  ResetImportErrorCurrentPage = '[ImportErrors] Reset Import Error Current Page',
  ImportMissingRecipes = '[ImportErrors] Import Missing Recipes',
  ImportMissingMenu = '[ImportErrors] Import Missing Menu'
}

export const loadImportErrors = createAction(
  AdminActionTypes.LoadImportErrors,
  props<{ importErrors: ImportError[] }>()
);

export const upsertImportErrors = createAction(
  AdminActionTypes.UpsertImportErrors,
  props<{ importErrors: ImportError[] }>()
);

export const resetImportErrors = createAction(
  AdminActionTypes.ResetImportErrors
);

export const setImportErrorCurrentPage = createAction(
  AdminActionTypes.SetImportErrorCurrentPage,
  props<{ pageNo: number }>()
);

export const resetImportErrorCurrentPage = createAction(
  AdminActionTypes.ResetImportErrorCurrentPage
);

export const importMissingRecipes = createAction(
  AdminActionTypes.ImportMissingRecipes,
  props<{ clientId: number, recipeIds: number[] }>()
);

export const importMissingMenu = createAction(
  AdminActionTypes.ImportMissingMenu,
  props<{ menu: MenuImportDto }>()
);
